/*
 * @Author: HTT httishere0728@gmail.com
 * @Date: 2024-09-03 21:58:04
 * @LastEditors: HTT httishere0728@gmail.com
 * @LastEditTime: 2025-08-01 21:29:53
 * @FilePath: /widverse-v2/src/constants/balance.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
type BALANCE_ITEM = {
  date: string
  max: number
  users: number
  archived: number
  status: number // -1: 待开始，0: 进行中，0.1:报名进行中，1:已结束, 0.5: 报名已结束
  title: string
  id: string
  type: string
  desc?: string
  reviews?: any[]
  link?: string
}

type BALANCE = {
  year: number
  childs: BALANCE_ITEM[]
}

export const colors: any = {
  减肥打卡: { color: '#704da8' },
  学习打卡: { color: '#8dc99f' },
  复盘打卡: { color: '#055ac9' },
}

export const reviewColors: any = {
  日复盘: '#feca88',
  周复盘: '#eb7faf',
  月复盘: '#5976ba',
}

export const balanceList: BALANCE[] = [
  {
    year: 2025,
    childs: [
      {
        date: '2025/03/01-2024/04/30',
        max: 89,
        users: 0,
        archived: 0,
        status: -1,
        title: 'No.1  学无止境',
        id: 'study.1',
        type: '学习打卡',
      },
      {
        date: '2025/02/09-2024/03/31',
        max: 30,
        users: 25,
        archived: 0,
        status: 1,
        title: 'No.1  年后冲刺',
        id: 'keep_2025.1',
        type: '减肥打卡',
        desc: '使用Notion进行记录打卡，每期15 - 60天<br>本计划可能会作为平台笔记进行分享（但不会包含真实信息相关内容），介意勿入<br>本计划仅作为个人监督督促非减肥竞赛，<strong style="font-weight: bold;">无任何奖励/惩罚</strong>，请大家如实记录（每期人数不多于30）<br>每期结束后重新开新计划并移除上一期小伙伴<br><strong style="color: red;font-weight: bold;">若报名按钮置灰或者报名链接失效则表示报名截止</strong>',
        link: 'https://httishere666.notion.site/1926018c38ee80068978d7c0e837b8e7?pvs=105',
      },
    ],
  },
  {
    year: 2024,
    childs: [
      {
        date: '2024/08/20-2024/12/31',
        max: 41,
        users: 5,
        archived: 0,
        status: 0,
        title: 'No.1 学会记录',
        id: 'review.1',
        type: '复盘打卡',
        reviews: [
          {
            title: '日复盘-2024年12月4日',
            image: './assets/bl/review/2024-12-04.jpg',
          },
          {
            title: '日复盘-2024年9月18日',
            image: './assets/bl/review/2024-09-18.jpg',
          },
          {
            title: '日复盘-2024年8月28日',
            image: './assets/bl/review/2024-08-28.jpg',
          },
          {
            title: '日复盘-2024年8月26日',
            image: './assets/bl/review/2024-08-26.jpg',
          },
          {
            title: '周复盘-2024年第34周',
            image: './assets/bl/review/2024-34w.jpg',
          },
          {
            title: '日复盘-2024年8月21日',
            image: './assets/bl/review/2024-08-21.jpg',
          },
        ],
      },
      {
        date: '2024/09/04-2024/09/30',
        max: 30,
        users: 25,
        archived: 0,
        status: 1,
        title: 'No.2 Keep on!',
        id: 'keep',
        type: '减肥打卡',
      },
      {
        date: '2024/08/06-2024/08/31',
        max: 30,
        users: 26,
        archived: 0,
        status: 1,
        title: 'No.1 Restart',
        id: 'restart',
        type: '减肥打卡',
        desc: '使用Notion进行记录打卡，每期15 - 30天<br>本计划将会作为平台笔记进行分享（但不会包含真实信息相关内容），介意勿入<br>本计划仅作为个人监督督促非减肥竞赛，<strong>无任何奖励/惩罚</strong>，请大家如实记录（每期人数不多于30）<br>每期结束后重新开新计划并移除上一期小伙伴<br>若报名按钮置灰或者报名链接失效则表示报名截止',
      },
    ],
  },
]
